<script lang="ts">
	/*
	 * This App comopnent is the main orchestrator of hub. It manages things like
	 * global state and routing.
	 */

	// Views
	import LoadingLayout from "./layouts/LoadingLayout.svelte";
	import Login from "./views/Login.svelte";
	import LoginRedirect from "./views/LoginRedirect.svelte";
	import Dashboard from "./v7/views/Dashboard.svelte";
	import Product from "./v7/views/Product.svelte";
	import Store from "./v7/views/Store.svelte";
	import StoreCreate from "./views/StoreCreate.svelte";
	import Revenue from "./v7/views/Revenue.svelte";
	import Profile from "./v7/views/Profile.svelte";
	import Place from "./v7/views/Place.svelte";
	import Earning from "./v7/views/Earning.svelte";

	import Notifications from "./v7/components/common/Alert.svelte";
	import AppLayout from "./layouts/AppLayout.svelte";
	// Utils
	import { Router, Route } from "svelte-routing";
	import {
		allStoreMode,
		storeIds,
		accessControlList,
		newAlert,
	} from "./v7/store";
	import {
		api,
		auth,
		token,
		user,
		profile,
		t,
		profileImage,
		refreshToken,
	} from "./stores";
	import RedirectHome from "./views/RedirectHome.svelte";
	import NoticeRouter from "./v7/Router/NoticeRouter.svelte";
	import { historyChangeEventDispatcher } from "./v7/utils";

	async function loadUser() {
		const r = await $api.getUser();
		$user = r.data;
	}
	async function loadAccessControl() {
		const r = await $api.getAccessControlByToken();
		//AllStoreMode 라면 모든 AccessControlDTO에 존재하는지 체크 아니라면 첫번째로 이동
		$accessControlList = r.data.accessControlListDTO.accessControlDTOList;
		if ($accessControlList.length === 0) {
			$storeIds = "";
			return;
		}
		if ($allStoreMode) {
			const storeIdArray = $storeIds.split("|");
			const hasPermission = $accessControlList.every((v) =>
				storeIdArray.find((id) => id === v.storeId)
			);
			if (!hasPermission) {
				$storeIds = $accessControlList[0].storeId;
			}
		} else {
			const storeIdArray = $storeIds;
			const hasPermission = $accessControlList.find(
				(v) => v.storeId === storeIdArray
			);

			if (hasPermission === undefined) {
				$storeIds = $accessControlList[0].storeId;
			}
		}
	}

	async function loadProfile() {
		const r = await $api.getProfile();
		$profile = r.data;
	}

	async function loadUnReadNews() {
		const { data } = await $api.getUnReadNewList();
		$newAlert.notice = data.totalElements !== 0;
	}

	let loadError = false;
	let loadedNoStroe = false;

	$: if ($token) loadUser().catch(() => (loadError = true));
	$: if ($token) loadProfile().catch(() => (loadError = true));
	$: if ($token) loadAccessControl().catch(() => (loadError = true));
	$: if ($token) loadUnReadNews().catch(() => (loadError = true));

	$: isLoaded = Boolean($accessControlList && $user && $profile);
	$: isLoggedIn = Boolean($token);
	$: isLoadedNoStore = Boolean(
		$user && $profile && $accessControlList?.length === 0
	);
	$: isLoaded ? profileImage.refreshProfileImage($api, $user!.id) : null;
	$: hasOwnStore = Boolean(
		($accessControlList?.filter((v) => v.permission === "STOREOWNER") || [])
			.length >= 1
	);
	$: presentAccessDTO = $accessControlList?.find(
		(v) => v.storeId === $storeIds
	);
	$: editable = !$allStoreMode && presentAccessDTO?.permission === "STOREOWNER";
	historyChangeEventDispatcher();
</script>

<Notifications />
<Router>
	{#if isLoggedIn}
		{#if isLoadedNoStore}
			<Route path="*">
				<StoreCreate loadedNoStroe />
			</Route>
		{:else if isLoaded}
			{#if !hasOwnStore}
				<Route path="/createstore">
					<StoreCreate />
				</Route>
			{/if}
			<Route path="*">
				<Router>
					<AppLayout>
						<Route path="/">
							<Dashboard storeIds={$storeIds.split("|")} />
						</Route>
						<Route path="/profile">
							<Profile />
						</Route>
						{#if $allStoreMode === false}
							<!-- 추후 위로 빼야함 -->
							<Route path="/revenue/*">
								<Revenue storeId={$storeIds} />
							</Route>
							<Route path="/store">
								<Store storeId={$storeIds} editable={editable} />
							</Route>
							<Route path="/product/*">
								<Product storeId={$storeIds} editable={editable} />
							</Route>
							<Route path="/earning/*">
								<Earning storeId={$storeIds} />
							</Route>
							<Route path="/notice/*">
								<NoticeRouter />
							</Route>
							<Route path="/place/*">
								<Place storeId={$storeIds} editable={editable} />
							</Route>
						{:else}
							<!-- Only For All Store mode  -->
							<Route path="/*">
								<RedirectHome />
							</Route>
						{/if}
					</AppLayout>
				</Router>
			</Route>
		{:else}
			<Route path="*">
				<LoadingLayout
					error={loadError ? $t("hub.app.loading_error") : ""}
					errorAction={$t("global.logout")}
					on:click={$auth.logout}
				/>
			</Route>
		{/if}
	{:else if !isLoggedIn}
		<Route path="/login">
			<Login />
		</Route>
		<Route path="*">
			<LoginRedirect refreshToken={$refreshToken} />
		</Route>
	{/if}
</Router>
